<template>
  <div>
    <!-- Content Header (Page header) -->
    <!-- Main content -->
    <section class="content">
      <div class="box info-box">
        <div class="box-header with-border">
          Search By
        </div>
        <div class="box-body">
          <div class="row">
            <div class="col-md-3" v-if="this.$store.state.user.type == 'admin'">
              <label for="Branch">Branch</label>
              <v-select v-model="branch" name="branch_id" label="name" :options="branches" v-on:input="branchRecordWithchangeFilter" placeholder="Select Branch"></v-select>
              <has-error
                :form="form"
                field="branch_id"
              ></has-error>
            </div>
            <div class="col-md-3" v-if="this.form.branch_id">
              <label for="Type">Type</label>
              <select
                v-model="form.planType"
                name="planType"
                @change="getPlanType"
                class="form-control"
                :class="{
                  'is-invalid': form.errors.has('planType'),
                }"
                required
              >
                <option v-if="!form.planType" selected value="">
                  Select plan Type
                </option>
                <option value="group">Group</option>
                <option value="individual">Individual</option>
              </select>
              <has-error
                :form="form"
                field="planType"
              ></has-error>
            </div>
            <div class="col-md-3" v-if="form.planType == 'group'"> 
              <label>Collection Center </label>
              <v-select v-model="colC"  name="collection_center_id" label="name" :options="collectionCenters" placeholder="Select Group" v-on:input="changeFilter" required> 
              </v-select>
            </div>
            <div class="col-md-3"> 
              <label>Customer</label>
              <v-select v-model="member"  name="collection_center_id" label="name" :options="members" placeholder="Select Group" v-on:input="changeFilterWithCustomer" required> 
              </v-select>
            </div>
            <div class="col-md-3">
              <label for="date">Date</label>
              <input type="date" v-model="form.paymentDate" name="paymentDate" @change="changeFilter(1)" class="form-control" placeholder="EMI Date">
            </div>
            <div class="col-sm-3">
              <div class="form-group">
                <label
                  >Select Status <span class="red">*</span></label
                >
                <select
                  v-model="form.status"
                  name="status"
                  class="form-control"
                  @change="changeFilter"
                  :class="{
                    'is-invalid': form.errors.has('status'),
                  }"
                >
                  <option v-if="!form.status" selected value="">
                    Select Status
                  </option>
                  <option value="pending">Pending</option>
                  <option value="processing">Processing</option>
                  <option value="sattlement">Settlement</option>
                  <option value="complete">Complete</option>
                </select>
                <has-error :form="form" field="status"></has-error>
              </div>
            </div>
          </div>
        </div>
        <!-- /.box-body -->
      </div>

      <!-- /.card -->
      <!-- <div class="box box-success">
        <div class="box-body">
          <div class="card">
            <div class="card-header">
              <span class="pull-right">
              </span>
              <h3 class="card-title">Loan Summary <span class="pull-right">Total Amount: {{this.totalAmount}}</span></h3>
              
            </div>
            <div class="card-body table-sm">
              <vue-good-table
                :columns="columnsMemberCollections"
                :rows="memberloanplans"
                styleClass="vgt-table condensed"
                :line-numbers="true"
                :pagination-options="{
                  enabled: true,
                  perPage: 10,
                  perPageDropdown: [10, 20, 30],
                }"
                :search-options="{
                  enabled: true,
                  trigger: 'enter',
                }"
              >
                <template slot="table-row" slot-scope="props">
                  <span v-if="props.column.field == 'DisbursementDate'">
                    {{props.row.disbursement.disbursementDate | myDate}}
                  </span>
                  <span v-if="props.column.field == 'id'">
                    
                    <button
                    class="btn btn-info btn-xs"
                    >
                    <router-link :to="/loanDetail/ + props.row.id" class="btn btn-info btn-xs"><i class="fa fa-eye"> Loan Details</i></router-link>
                    </button>
                  </span>
                  <span v-else>
                    {{ props.formattedRow[props.column.field] }}
                  </span>
                </template>
              </vue-good-table>
            </div>
          </div>
        </div>
      </div> -->

      <!-- Default box -->
      <div class="info-box"  v-if="canAccess('member-loan-plan-view-any')">
        <div class="box-header with-border">
          <h3 class="box-title">Loan Summary </h3>
          
          <div class="box-tools">
            <a :href="`${this.$axios.defaults.baseURL}/memberloanplan/export/excel`" class="btn btn-box-tool" v-if="canAccess('member-loan-plan-create')">
              <i class="fa fa-file-excel-o"></i> Download Excel
            </a>
            <!-- <button type="button" class="btn btn-success btn-sm" @click="newModal" v-if="canAccess('branch-create')">
              <i class="fa fa-plus"></i> Add New
            </button> -->
          </div>

        </div>
        <div class="box-body">
          <div class="row">
            <div class="col-sm-6 col-xs-6">
              <label>
                <select v-model="per_page" name="per_page" @change="changeFilter()" aria-controls="example1" class="form-control input-sm">
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
              </label>
            </div>
            <div class="col-sm-6 col-xs-6">
              <div class="input-group pull-right input-group-sm" style="width: 150px;">
                <input type="text" v-model="table_search" @keyup.enter="changeFilter()" name="table_search" class="form-control pull-right" placeholder="Search">

                <div class="input-group-btn">
                  <button type="button" @click="changeFilter()" class="btn btn-default"><i class="fa fa-search"></i></button>
                </div>
              </div>
            </div>
          </div>
          <table class="table table-sm table-bordered table-hover">
            <thead style="background-color: #d6dddd;">
              <tr>
                <th class="hidden-xs">Sr. No.</th>
                <th>LoanID </th>
                <th>Mem Name </th>
                <th class="hidden-xs">Mem Code </th>
                <th class="hidden-xs">Mobile</th>
                <!-- <th class="hidden-xs">Type</th> -->
                <th class="hidden-xs">CenterName</th>
                <th class="hidden-xs">Branch</th>
                <th class="hidden-xs">Disb Date</th>
                <th class="hidden-xs">Plan Amt</th>
                <th class="hidden-xs">Disb Amt</th>
                <th>Amount</th>
                <th class="hidden-xs">Rec. Amount</th>
                <th class="hidden-xs">Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in memberloanplans" :key="index">
                <td class="hidden-xs">{{ (index + pagination.from) }}</td>
                <td>{{ row.applicationNo }}</td>
                <td>{{ row.member.name }}</td>
                <td class="hidden-xs">{{ row.member.code }}</td>
                <td class="hidden-xs">{{ row.member.mobile }}</td>
                <!-- <td class="hidden-xs">{{ row.type }}</td> -->
                <td class="hidden-xs"><span v-if="row.collection_center_id">{{ row.collection_center.name }}</span></td>
                <td class="hidden-xs">{{ row.branch.name }}</td>
                <td class="hidden-xs">{{ row.disbursement.disbursementDate | myDate}}</td>
                <td class="hidden-xs">{{ getPlanAmt(row.disbursement)}}</td>
                <td class="hidden-xs">{{ getDisbursementAmt(row.disbursement)}}</td>
                <td>{{ row.totalAmt }}</td>
                <td class="hidden-xs">{{ row.receivedAmt }}</td>
                <td class="hidden-xs">
                  <span class="label label-warning" v-if="row.status == 'pending'">{{ row.status }}</span>
                  <span class="label label-info" v-if="row.status == 'processing'">{{ row.status }}</span>
                  <span class="label label-danger" v-if="row.status == 'sattlement'">{{ row.status }}</span>
                  <span class="label label-success" v-if="row.status == 'complete'">{{ row.status }}</span>
                </td>
                <td>
                    <router-link :to="/loanDetail/ + row.id + '/' + row.disbursement_id" class="btn btn-primary btn-xs"><i class="fa fa-eye"> Details</i></router-link>
                    
                  <button v-if="row.status === 'sattlement' || row.status === 'complete'" class="btn btn-warning btn-xs" @click="getNoc(row)">
                    NOC
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- /.box-body -->
        <div class="box-footer clearfix" v-if="pagination.current_page > 0">
          <div class="row">
            <div class="col-sm-4">
              Showing {{pagination.from}} to {{pagination.to}} of {{pagination.total}} entries
            </div>
            <div class="col-sm-8">
              <ul class="pagination pagination-sm no-margin pull-right">
                <li @click="changeFilter(null, 'first')"><a href="#">&laquo;</a></li>
                <li @click="changeFilter(null, 'prev')"><a href="#">Prev</a></li>

                <!-- <li v-if="pagination.current_page > 4" @click="changeFilter( pagination.current_page - 4 )"><a href="#">{{pagination.current_page - 4}}</a></li> -->
                <li v-if="pagination.current_page > 3" @click="changeFilter( pagination.current_page - 3 )"><a href="#">{{pagination.current_page - 3}}</a></li>
                <li v-if="pagination.current_page > 2" @click="changeFilter( pagination.current_page - 2 )"><a href="#">{{pagination.current_page - 2}}</a></li>
                <li v-if="pagination.current_page > 1" @click="changeFilter( pagination.current_page - 1 )"><a href="#">{{pagination.current_page - 1}}</a></li>
                <li class="active" @click="changeFilter( pagination.current_page )"><a href="#">{{ pagination.current_page }}</a></li>
                <li v-if="pagination.current_page < (pagination.last_page - 4)" @click="changeFilter( pagination.current_page + 1 )"><a href="#">{{pagination.current_page + 1}}</a></li>
                <li v-if="pagination.current_page < (pagination.last_page - 5)" @click="changeFilter( pagination.current_page + 2 )"><a href="#">{{pagination.current_page + 2}}</a></li>
                <li v-if="pagination.current_page < (pagination.last_page - 6)" @click="changeFilter( pagination.current_page + 3 )"><a href="#">{{pagination.current_page + 3}}</a></li>
                <!-- <li v-if="pagination.current_page < (pagination.last_page - 4)" @click="changeFilter( pagination.current_page + 4 )"><a href="#">{{pagination.current_page + 4}}</a></li> -->
                <li><a href="#">...</a></li>
                
                <!-- <li v-if="pagination.current_page < (pagination.last_page - 4)" @click="changeFilter( pagination.last_page - 4 )"><a href="#">{{pagination.last_page - 4}}</a></li> -->
                <li v-if="pagination.current_page < (pagination.last_page - 3)" @click="changeFilter( pagination.last_page - 3 )"><a href="#">{{pagination.last_page - 3}}</a></li>
                <li v-if="pagination.current_page < (pagination.last_page - 2)" @click="changeFilter( pagination.last_page - 2 )"><a href="#">{{pagination.last_page - 2}}</a></li>
                <li v-if="pagination.current_page < (pagination.last_page - 1)" @click="changeFilter( pagination.last_page - 1 )"><a href="#">{{pagination.last_page - 1}}</a></li>
                <li @click="changeFilter( pagination.last_page )"><a href="#">{{pagination.last_page}}</a></li>

                <li @click="changeFilter(null, 'next')"><a href="#">Next</a></li>
                <li @click="changeFilter(null, 'last')"><a href="#">&raquo;</a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <!-- /.box -->
      <!-- Demand Probeshnary note  -->
      <noc :seeRecord="seeRecord" :getCompanyRecord="getCompanyRecord" :logo="logo"></noc>
      <!-- /.modal -->

    </section>
    <!-- /.content -->
  </div>
</template>
<script>
import GetBranch from '../../mixins/BranchRecords'
import GetDisbursementAmount from '../../mixins/GetDisbursementAmount'
import GetPlanAmount from '../../mixins/GetPlanAmount'
import noc from '../components/Noc.vue'
export default {
  name: 'my-component',
  mixins: [GetBranch, GetDisbursementAmount, GetPlanAmount],
  data () {
    return {
      pagination: {
        current_page: 0,
        from: 0,
        to: 0,
        total: 0,
        last_page: 0,
        per_page: 0,
        first_page_url: null,
        last_page_url: null,
        next_page_url: null,
        prev_page_url: null,
        path: null
      },
      per_page: 10,
      table_search: '',
      editMode: false,
      emiDate: null,
      collectionCenters: [],
      collectionCenter: {
        name: 'Select Group'
      },
      planAmt: '',
      DisbursementAmt: '',
      logo: '',
      branch_record: '',
      applicationNumber: '',
      memberCode: '',
      mobileNumber: '',
      adharCardNumber: '',
      pancardNumber: '',
      getCompanyRecord: {},
      branches: [],
      branch: {},
      members: [],
      member: {},
      staffs: {},
      banks: {},
      colC: {},
      pl: {},
      seeRecord: {},
      loanplans: [],
      memberloanplan: {},
      groupMembers: {},
      getSettingRecord: '',
      loadDisbursements: {},
      totalAmount: 0,
      viewCollectionCenter: '',
      form: new Form({
        id: '',
        collection_center_id: '',
        member_loan_plan_id: null,
        branch_id: '',
        agent_id: '',
        center_leader_id: '',
        plan_id: '',
        amt: '',
        plan: {},
        planType: '',
        member_id: '',
        status: '',
        disbursement_id: '',
        paymentDate: '',
        emiStartDate: '',
        paymentMode: '',
        bank_id: ''
      }),
      // columnsMemberCollections: [
      //   {
      //     label: 'BRANCH CODE',
      //     field: 'branch.branchCode'
      //   },
      //   {
      //     label: 'LOAN ID',
      //     field: 'applicationNo'
      //   },
      //   {
      //     label: 'MEM CODE',
      //     field: 'member.code'
      //   },
      //   {
      //     label: 'MEM NAME',
      //     field: 'member.name'
      //   },
      //   {
      //     label: 'MEM MOB',
      //     field: 'member.mobile'
      //   },
      //   {
      //     label: 'TYPE',
      //     field: 'type'
      //   },
      //   {
      //     label: 'DISBURSEMENT DATE',
      //     field: 'DisbursementDate'
      //   },
      //   {
      //     label: 'AMOUNT',
      //     field: 'totalAmt'
      //   },
      //   {
      //     label: 'RECEIVED AMOUNT',
      //     field: 'receivedAmt'
      //   },
      //   {
      //     label: 'ACTIONS',
      //     field: 'id',
      //     type: 'number'
      //   }
      // ],
      memberloanplans: []
    }
  },
  components: {
    noc
  },
  methods: {
    canAccess (perm) {
      return this.$store.state.permissions.includes(perm)
    },
    // getBranchBy () {
    //   // alert('hello')
    //   this.form.branch_id = this.branch.id
    //   this.changeFilter()
    // },
    branchRecordWithchangeFilter () {
      this.form.branch_id = ''
      if (this.branch) {
        this.form.branch_id = this.branch.id
      }
      this.changeFilter()
    },
    getMembers () {
      var c = JSON.parse(localStorage.user)
      this.userStatus = ''
      if (c.type !== 'admin') {
        if (c.role.name === 'Manager') {
          this.branch_record = `branch_id=${c.agent_profile.branch_id}`
        } else {
          this.branch_record = `&agent_id=${c.id}`
        }
      } else {
        this.branch_record = `branch_id=${this.form.branch_id}`
      }
      if (this.getSettingRecord === 'true') {
        this.userStatus = 'status=verified'
      }
      this.$axios
        .get('member?all=all&' + this.userStatus + '&' + this.branch_record, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.members = data.data
          _.forEach(this.members, function (item, key) {
            this.members[key].name = item.user.name + ' (' + item.user.code + ' - ' + item.user.mobile + ')'
            if (this.form.member_id === item.user.id) {
              this.mem = item
            }
          }.bind(this))
        })
        .catch(
          function (error) {
            if (error.response.data.error) {
              var result = []
              var er = error.response.data.error
              for (var l in er) {
                if (er.hasOwnProperty(l)) {
                  result.push(l + ': ' + er[l])
                }
              }
              Toast.fire({ icon: 'error', title: result.join('\n') })
            }
            if (error.response.data.message) {
              let er = error.response.data.message
              Toast.fire({ icon: 'error', title: er })
            }
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },
    changeFilterWithCustomer () {
      this.form.member_id = ''
      if (this.member) {
        this.form.member_id = this.member.user_id
      }
      this.changeFilter()
    },
    confirmPayment (row) {
      Swal.fire({ title: 'Are you sure?', text: 'You Delete this Payment !', icon: 'warning', showCancelButton: true, confirmButtonColor: '#3085d6', cancelButtonColor: '#d33', confirmButtonText: 'Yes, Save it!' })
      .then((result) => {
        if (result.isConfirmed) {
          this.$axios.delete('membercollection/' + row.id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
            .then(() => {
              Fire.$emit('AfterCreate')
              Swal.fire('Paid!', 'Payment Paid Successfully.', 'success')
            })
        }
      })
    },
    getNoc (row) {
      this.seeRecord = row
      this.loadCompanyProfile()
      $('#viewPrintNoc').modal({backdrop: 'static', keyboard: false})
    },
    loadCompanyProfile () {
      let loader = this.$loading.show()
      this.$axios
        .get('settings', {
          headers: { Authorization: 'Bearer ' + localStorage.token }
        })
        .then((response) => response.data)
        .then((data) => {
          loader.hide()
          this.getCompanyRecord = data
          if (this.getCompanyRecord.logo != null) {
            this.logo = this.$store.state.imageBaseUrl + 'logo/' + this.getCompanyRecord.logo
          } else {
            alert('hello')
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    planName (plan) {
      var pln = JSON.parse(plan)
      this.form.member_loan_plan_id = null
      return pln.name
    },
    changeFilter (page = null, pg = null) {
      var c = JSON.parse(localStorage.user)
      // alert('hello')
      var pageUrl = ''
      if (this.pagination.first_page_url && pg === 'first') {
        pageUrl += this.pagination.first_page_url
      } else if (this.pagination.last_page_url && pg === 'last') {
        pageUrl += this.pagination.last_page_url
      } else if (this.pagination.next_page_url && pg === 'next') {
        pageUrl += this.pagination.next_page_url
      } else if (this.pagination.prev_page_url && pg === 'prev') {
        pageUrl += this.pagination.prev_page_url
      } else if (this.pagination.path != null) {
        pageUrl += this.pagination.path
      } else {
        pageUrl += 'memberloanplan'
      }

      if (pg == null) {
        pageUrl += `?per_page=${this.per_page}`
      } else {
        pageUrl += `&per_page=${this.per_page}`
      }
      if (c.type === 'admin') {
        if (this.form.branch_id) {
          pageUrl += `&branch_id=${this.form.branch_id}`
        }
      }
      if (c.type !== 'admin') {
        if (c.role.name === 'Manager') {
          this.form.branch_id = c.agent_profile.branch_id
          pageUrl += `&branch_id=${this.form.branch_id}`
        } else {
          pageUrl += `&agent_id=${c.id}`
        }
      }
      if (this.form.member_id) {
        pageUrl += `&member_id=${this.form.member_id}`
      }
      if (this.form.status) {
        pageUrl += `&status=${this.form.status}`
      }
      if (this.form.planType) {
        pageUrl += `&type=${this.form.planType}`
      }
      if (this.colC.id) {
        pageUrl += `&collection_center_id=${this.colC.id}`
      }
      if (this.form.paymentDate) {
        pageUrl += `&disbursementDate=${this.form.paymentDate}`
      }
      if (this.table_search) {
        pageUrl += `&searchTerm=${this.table_search}`
      }
      if (page != null) {
        pageUrl += `&page=${page}`
      }
      this.$axios
        .get(pageUrl, {headers: { Authorization: 'Bearer ' + localStorage.token }}).then((response) => response.data)
        .then((data) => {
          console.log(data)
          this.memberloanplans = data.data.data
          this.pagination = data.data
        }).catch(function (error) { console.log(error) })
    },
    // getMemberLoanPlan () {
    //   this.$axios
    //     .get('memberloanplan?all=all&branch_id=' + this.form.branch_id + '&searchTerm=' + this.form.planType + '&collection_center_id=' + this.form.collection_center_id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
    //     .then((response) => response.data)
    //     .then((data) => {
    //       // console.log(data.data)
    //       this.memberloanplans = data.data
    //       this.totalAmount = _.sumBy(data.data, 'totalAmt')
    //     })
    //     .catch(function (error) {
    //       console.log(error)
    //     })
    // },
    getLoanDetailsMemberCode () {
      this.$axios
      .get('memberloanplan?all=all&applicationNo=' + this.memberCode, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          // console.log(data.data.data)
         // alert(data.data.data)
          this.form.member_loan_plan_id = data.data[0]['id']
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    getPlanType () {
      this.form.collection_center_id = ''
      this.form.member_loan_plan_id = ''
      this.collectionCenters = []
      this.colC = {}
      this.memberloanplans = []
      this.rows = []
      this.rowsMemberCollections = []
      if (this.form.planType === 'individual') {
        this.collectionCenter = {'name': 'Select Group'}
      }
      if (this.form.planType === 'group') {
        this.$axios.get('collectioncenter?all=all&branch_id=' + this.form.branch_id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
          .then((response) => response.data)
          .then((data) => {
            this.collectionCenters = data.data
          })
          .catch(
            function (error) {
              Toast.fire({ icon: 'error', title: 'Please Try Again' })
              this.form.errors.errors = error.response.data.error
            }.bind(this)
          )
      }
      this.changeFilter()
    }
  },

  created () {
    this.getBranch()
    this.getMembers()
    this.changeFilter()
  }
}
</script>
<style scoped>
.content {
    padding: 0px;
  }
.info-box {
    border-radius:10px;
    box-shadow: 0px 0px 3px gray;
  }
  .box-footer {
    border-radius:0px 0px 10px 10px;
  }
</style>



// WEBPACK FOOTER //
// LoanSummary.vue?8c179bba